export const haveDifferentKeys = (a, b, key = 'key') => a.length !== b.length || Boolean(a.find(item => !b.find(i => i[key] === item[key])));


// WEBPACK FOOTER //
// ./src/utils/compare.js